import { type PropsWithChildren } from 'react'
import { FatecieIcon } from '@/assets/icons/fatecie-icon'
import TransfereFacilIcon from '@/assets/icons/trasnfere-facil-icon'
import { Show } from '@/components/show'
import { StudentSession } from '@/components/user/user-session'
import { useStudentSessionStore } from '@/store/student-session-store'
import { PageLoading } from '../page-layout/page-loading'

interface PageLayoutProps extends PropsWithChildren {
  className?: string
  withLogoHeader?: boolean
  isLoading?: boolean
  loadingTitle?: string
}

export const StudentLayout = ({
  children,
  withLogoHeader,
  isLoading,
  loadingTitle
}: PageLayoutProps) => {
  const { name } = useStudentSessionStore()

  function renderLoading() {
    return <PageLoading goingTo={loadingTitle || 'Página'} />
  }

  function renderPage() {
    return (
      <div className="w-350 mx-auto min-h-[calc(100dvh-120px)]">
        <Show when={withLogoHeader || false}>
          <FatecieIcon />
          <div className="border-b border-muted-foreground/60 mt-2 mb-10 w-full"></div>
        </Show>
        {children}
      </div>
    )
  }

  return (
    <>
      <div className="bg-[var(--brand-blue-3)] flex items-center justify-between h-20 mb-10 px-12">
        <div className="flex gap-3 items-center">
          <TransfereFacilIcon className="h-10" />
          <p className="text-background font-bold text-2xl">Transfere fácil</p>
        </div>
        <Show when={!isLoading}>
          <StudentSession name={name} />
        </Show>
      </div>
      <Show when={isLoading}>{renderLoading()}</Show>
      <Show when={!isLoading}>{renderPage()}</Show>
    </>
  )
}
